import React from "react";
import "./Logic.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Logic = () => {
  return (
    <div className="project-details-container">
      <header className="project-details-header">
        <h1>Backend Logic Development Details</h1>
      </header>
      <div className="topimages-container">
        <img
          src="/images/backend/backend-is.png"
          alt="Top Banner"
          className="topimages-image"
        />
        
      </div>
      <section className="project-details-content">
        <div className="detail-section">
          <h2>
            <i className="fas fa-info-circle"></i> What is Backend Development?
          </h2>
          <p>
            Backend development refers to all the processes that enable web and mobile
            applications to perform well. It focuses on the functionality and interconnection
            of the application’s internal processes. Without the backend, the frontend
            cannot function effectively, making both sides equally important.
          </p>
        </div>
        <div className="structure-container">
        <img
          src="/images/backend/developer-responsebilities.png"
          alt="Top Banner "
          className="structure-image"
        />
      </div>
        <div className="detail-section">
          <h2>
            <i className="fas fa-user-tie"></i> Who is a Backend Engineer?
          </h2>
          <p>
            Backend engineers are responsible for server-side development. They write code
            to implement business logic, develop APIs, manage data architecture, and ensure
            smooth application functionality. Additionally, serverless backends, such as
            FaaS or BaaS, allow developers to leverage cloud-based backend functions for
            faster integration and reduced costs.
          </p>
        </div>

        <div className="detail-section">
          <h2>
            <i className="fas fa-tasks"></i> Backend Developer Requirements
          </h2>
          <ul>
            <li>Proficiency in backend languages like Node.js, Python, Kotlin, etc.</li>
            <li>Understanding of database systems like MySQL, MongoDB, or Redis.</li>
            <li>Knowledge of backend frameworks and libraries.</li>
            <li>Ability to address security concerns effectively.</li>
            <li>Familiarity with frontend fundamentals like HTML and CSS.</li>
          </ul>
        </div>

        <div className="detail-section">
          <h2>
            <i className="fas fa-clipboard-check"></i> Roles and Responsibilities
          </h2>
          <ul>
            <li>Define the application's goals and objectives.</li>
            <li>Ensure secure storage and data access for users.</li>
            <li>Handle payment processing and system logic across devices.</li>
            <li>Develop APIs, libraries, and business processes.</li>
            <li>Address system-related issues and maintain data integrity.</li>
          </ul>
        </div>

        <div className="detail-section">
          <h2>
            <i className="fas fa-cogs"></i> Backend Features for Applications
          </h2>
          <p>
            A backend is required for dynamic applications involving user authentication,
            payment systems, or real-time data processing. For static pages, frontend-only
            development may suffice. Key backend components include:
          </p>
          <ul>
            <li><strong>Tech Stack:</strong> Servers, databases, OS, and frameworks.</li>
            <li><strong>APIs:</strong> Facilitate data exchange between software and databases.</li>
            <li><strong>Frameworks:</strong> Predefined code structures to build server logic.</li>
          </ul>
        </div>

        <div className="detail-section">
          <h2>
            <i className="fas fa-database"></i> Database Preferences
          </h2>
          <p>
            Depending on the application’s requirements, you may choose:
          </p>
          <ul>
            <li><strong>MySQL/PostgreSQL:</strong> For structured, relational data.</li>
            <li><strong>MongoDB:</strong> For flexible, unstructured data.</li>
            <li><strong>Firebase:</strong> For real-time, cloud-based NoSQL solutions.</li>
          </ul>
        </div>

        <div className="detail-section">
          <h2>
            <i className="fas fa-tools"></i> Specific Features
          </h2>
          <ul>
            <li><strong>Authentication:</strong> Secure API communication with JWT or OAuth.</li>
            <li><strong>Scalability:</strong> Utilize microservices or serverless architecture.</li>
            <li><strong>Data Validation:</strong> Validate input using libraries like Joi.</li>
            <li><strong>Caching:</strong> Optimize performance with Redis or Memcached.</li>
          </ul>
        </div>

        <div className="detail-section">
          <h2>
            <i className="fas fa-code"></i> Preferred Frameworks
          </h2>
          <p>Choose the right framework based on the tech stack:</p>
          <ul>
            <li><strong>Node.js:</strong> Express for lightweight apps, NestJS for structured development.</li>
            <li><strong>Python:</strong> Django for built-in features, Flask for minimalistic solutions.</li>
            <li><strong>Kotlin:</strong> Spring Boot or Ktor for fast web servers.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Logic;
